import { useState, useEffect } from 'react';
import { DeviceType } from '../Types';
import { useGlobalContext } from '../Context/GlobalContext';
import { getImage } from '../Lib/Devices'
import DeleteIcon from '@mui/icons-material/Delete';

const Product = ({
    deviceId, 
    deviceHardwareId,
    type, 
    onClick, 
    className, 
    gifMode, 
    handleDelete
} : {
    deviceId?: number, 
    deviceHardwareId?: string, 
    type: DeviceType, 
    onClick?: Function, 
    className?: String, 
    gifMode?: String, 
    handleDelete?: Function
}) => {
    const { theme, connectedDevices, getThemeImage } = useGlobalContext();
    const connectedSrc = getThemeImage(`Ellipse`);
    const [imgSrc, setImgSrc] = useState<string|undefined>(`/assets/devices/${theme}/${getImage(type.code)}.png`);

    useEffect(() => {
        if(gifMode === "on") setImgSrc((prevSrc) => prevSrc?.replace('.png', '.gif'));
    }, [gifMode]);

    useEffect(() => {
        toggleTheme();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [theme]);

    const toggleTheme = () => {
        setImgSrc((prevSrc) => theme.includes('light') ? prevSrc?.replace('dark', 'light') : prevSrc?.replace('light', 'dark')) 
    }

    const handleMouseEnter = () => {
        if (gifMode === 'none' || gifMode === 'on') return;
        setImgSrc((prevSrc) => prevSrc?.replace('.png', '.gif'));
    }

    const handleMouseLeave = () => {
        if (gifMode === 'on') return;
        setImgSrc((prevSrc) => prevSrc?.replace('.gif', '.png'));
    }

    return (
        <div className='product-container'>
            <div className={`product ${gifMode ? '' : 'gif'} ${className ?? ''}`} onClick={() => onClick && onClick()}>
                {type.status === 'coming_soon' ? <div className="coming-soon">Coming Soon</div> : ''}
                {   
                    connectedDevices.includes(deviceHardwareId ?? '') && <img src={connectedSrc} alt="connected" className="connected"/>
                }

                <img 
                    onMouseEnter={handleMouseEnter} 
                    onMouseLeave={handleMouseLeave}
                    src={imgSrc} 
                    alt={type.name} 
                    className='product-image'
                />
                {deviceId && handleDelete && <div style={{display: 'flex', justifyContent: 'end', width: '100%'}}>
                    <DeleteIcon onClick={(e) => {
                        e.stopPropagation();
                        handleDelete(deviceId);
                    }} />
                </div>}
            </div>
        </div>
    )
}

export default Product;